/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![VoiceBluetoothIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABGElEQVR4nOWVu0pDQRCGV6xEsPeBIinOXE6xzC9JbaFYaiGIpaUv4CMk4Bvkho2IjT6ItQjKnLhyjDEcPSdByA/bzC7/N7OX2RDWQnne2WW1JxabNG7ebnd2SO2BFW8+GjWPMW6RYpTMGwXEGDdZ0C+bNwnYYMX1rPkiAOc4IrHzHx1JcTvPkCsCSDGYrrErT/B7BhXMuQQgtQNWXPhWJgCJvZQgNQGC0yImuGm1uttFBWJDN/c4iZ3VArgy2T8kwSup3bPgkQV3Dvyo4iTUBbgytT0SPKf5Aig4DrP6K8BFim4JcBnm6V9WkC3zDOjXt0hsstR3ULdV0NeXXLHZqfWqAqbnsaAXrbxdr+TDSUpfJinGn8G10TvN3o+RNdmmUQAAAABJRU5ErkJggg==)
 */
export const VoiceBluetoothIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 3a1 1 0 0 0-1-1h-.06a1 1 0 0 0-.74.32L5.92 7H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2.92l4.28 4.68a1 1 0 0 0 .74.32H11a1 1 0 0 0 1-1V3Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M19.53 6.47a.75.75 0 0 0-1.28.53v3.8l-2.76-2.37a.75.75 0 1 0-.98 1.14l3.42 2.93-3.42 2.93a.75.75 0 1 0 .98 1.14l2.76-2.37V18a.75.75 0 0 0 1.28.53l3-3a.75.75 0 0 0-.04-1.1l-2.25-1.93 2.25-1.93a.75.75 0 0 0 .04-1.1l-3-3Zm1.37 8.57-1.15-.98v2.13l1.15-1.15Zm-1.15-6.23v2.13l1.15-.98-1.15-1.15Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
